var Acr = Acr || {};

Acr.VehicleLineup = function () {

  var $vehicleLineup;
  var $vehicleLineupList;
  var $vehicleLineupTiles;
  const lineupListSelectorClass = '.js-lineup-list';
  const lineupTileSelectorClass = '.js-lineup-tile';
  const animatedClass = 'animated';
  const fadeInUpScatterClass = 'acr-fade-in-up-scatter';

  function initSelectors(element) {
    $vehicleLineup = element;
    $vehicleLineupList = $vehicleLineup.querySelector(lineupListSelectorClass);
    $vehicleLineupTiles = $vehicleLineup.querySelectorAll(lineupTileSelectorClass);
  }

  function addClassesToObject(observedObject) {
    var classListObserver = [animatedClass, fadeInUpScatterClass];
    classListObserver.forEach(function (observerClass) {
      observedObject.classList.add(observerClass);
    });
  }

  function initObservers() {
    Utility.addIntersectionObserver($vehicleLineupList, addClassesToObject);
    $vehicleLineupTiles.forEach($vehicleLineupTile => Utility.addIntersectionObserver($vehicleLineupTile, addClassesToObject));
  }

  function init(element) {
    initSelectors(element);
    initObservers();
  }

  return {
    init: init,
  };
};
